import React, { Suspense, useState, useEffect } from "react";
import ReactSelect from "react-select";
import InputRange from "react-input-range";
import {
 
  CircularProgress,
} from "@mui/material";
import "react-input-range/lib/css/index.css";
import "../CreateWhishlist/CreateWhishlist.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Label } from "reactstrap";
import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";
import CheckboxTree from "react-checkbox-tree";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,

  MdAdd,
  MdRemove,
} from "react-icons/md";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import PerfectScrollbar from "react-perfect-scrollbar";
import "antd/dist/antd.css";
import makeAnimated from "react-select/animated";
import { FiSearch } from "react-icons/fi";
import { FaRegCalendarAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import {
  addPropertyWatch,
  getPropertyWatch,
} from "../../actions/propertyAction";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { dropdownPropertyField } from "../../actions/propertyFieldAction";
import  {  useHistory, } from "react-router-dom";
import moment from "moment";
import { connect,useSelector  } from "react-redux";
import { runningSubscription } from "../../actions/subscription";
import "../CreateWhishlist/wishlist.scss";
import {
  isFutureDate,isValidDateRange
  } from "../../Helpers/Validation";
import swal from "sweetalert";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import Nodes from "../../Helpers/nodesList.js";
const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};

const colourStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#999999" : null,
      color: "#333333",
    };
  },
};

const PropertiesWatch = ({ label,dropdownPropertyField ,addPropertyWatch, getPropertyWatch,}) => {
  const { frontLabelsName } = label;
   const dispatch = useDispatch();
   let isSubscribing =localStorage.getItem("isSubscribing")==="true"
const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;
 const nodes = Nodes(); 
  const history = useHistory();
  const animatedComponents = makeAnimated();
  const lng = localStorage.getItem("prevLangFront") ;
const[disableSubmitButton,setDisableSubmitButton]=useState(false)
  const [clickedTree, setClickedTree] = useState([]);
    const [checkedTree, setCheckedTree] = useState(["0"]);
    const [expandedTree, setExpandedTree] = useState(["0"]);
      const [availableFrom, setAvailableFrom] = useState(new Date());
      const [availableTo, setAvailableTo] = useState(new Date());
        const [shortTerm, setShortTerm] = useState(true);
        const [longTerm, setLongTerm] = useState(false);
    const [openZip, setOpenZip] = useState(false);
   
  const [streetName, setStreetName] = useState("");
  const [notified, setNotified] = useState([]);
 const [propertyType, setPropertyType] = useState(null);
  const [price, setPrice] = useState({ min: 100, max: 2000000 });
  const [size, setSize] = useState({ min: 0, max: 10000 });
  const [propertyRoom, setPropertyRoom] = useState([]);

    const [homeApplianceType, setHomeApplianceType] = useState(null);
    const [restrictionsType, setRestrictionsType] = useState([]);
    const [accessType, setAccessType] = useState([]);
    const [otherTypeField, setOtherTypeField] = useState([]);

     const [selectedOtherData, setSelectedOtherData] = useState([]);
      const [selectedAccessData, setSelectedAccessData] = useState([]);
      const [selectedHomeApplianceData, setSelectedHomeApplianceData] = useState(
        []
      );
      const [selectedRestrictionData, setSelectedRestrictionData] = useState([]);

  // error
  const [error_howWouldYouLikeToNotified, setError_HowWouldYouLikeToNotified] =
    useState();

  const [error_zipcode, seterror_zipcode] = useState();
  const [error_apartmentType, seterror_apartmentType] = useState();
  const [error_propertyRoom, seterror_propertyRoom] = useState();
  const [error_rentalPeriod, seterror_rentalPeriod] = useState();
  const [error_price, seterror_price] = useState();
  const [error_size, seterror_size] = useState();
  const [error_advance, seterror_advance] = useState();
  const [error_streetName, seterror_streetName] = useState("");
  const [error_extraItem, seterror_extraItem] = useState("");
  const[fromDateError,setFromDateError] = useState("");
  const[toDateError,setToDateError] = useState("");

   useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const propertyRoomArr = [{label:frontLabelsName
    ? frontLabelsName.filter((e) => e.key == "lbl_storage")
      .length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_storage"
      )[0]["value"] || "lbl_storage"
      : "lbl_storage"
    : "lbl_storage",value:"Storage"},{label:frontLabelsName
      ? frontLabelsName.filter((e) => e.key == "lbl_single_room")
        .length > 0
        ? frontLabelsName.filter(
          (e) => e.key == "lbl_single_room"
        )[0]["value"] || "lbl_single_room"
        : "lbl_single_room"
      : "lbl_single_room",value:'Single Room'},{label:frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_studio")
          .length > 0
          ? frontLabelsName.filter(
            (e) => e.key == "lbl_studio"
          )[0]["value"] || "lbl_studio"
          : "lbl_studio"
        : "lbl_studio",value:'Studio'},{label:"2",value:'2'} ,{label:"3",value:'3'} ,{label:"4",value:'4'} ,{label:"5+",value:'5'}  ];
  const includs = (filedData, newData) => {
    let result = filedData.filter(function (obj) {
      return newData.some(function (val) {
        return val === obj._id;
      });
    });
    let selectedIds = result?.map((item) => {
      return item._id;
    });

    return selectedIds;
  };

  const options = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house",
      value: "detachedHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex",
      value: "duplex",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house",
      value: "tripleAptHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
            "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building",
      value: "aptBulding",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin",
      value: "townhouseTwin",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage",
      value: "garage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
            "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house",
      value: "summerHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
            "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant",
      value: "cotenant",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house",
      value: "hotelGesthouse",
    },
  ];
  // Function for filtering data
const includes = (filedData, newData) => {
  const newDataSet = new Set(newData);
  return filedData
    .filter(item => newDataSet.has(item._id))
    .map(item => item._id);
};
    useEffect(() => {
    dropdownPropertyField("").then((res) => {
        setHomeApplianceType(res?.type_2);
        setRestrictionsType(res?.type_3);
        setAccessType(res?.type4);
        setOtherTypeField(res?.type5);
      });
    }, []);
      useEffect(() => {
        // setLoading(true);
        if(homeApplianceType&&homeApplianceType){
      getPropertyWatch().then((res) => {
        if(res){
      let tempnotify=[]
      if(res?.user?.property_watch_email){
        tempnotify.push('email')
      }
      if(res?.user?.property_watch_sms){
        tempnotify.push('sms')
      }
      if(res?.user?.property_watch_web){
        tempnotify.push('web')
      }
      setNotified(tempnotify)
        setStreetName(res?.location)
          setCheckedTree(res?.area);
         
    
          setPropertyRoom(res?.bhk);
    
          if (res?.other.length > 0 && homeApplianceType?.length>0) {
            setSelectedOtherData(includes(otherTypeField, res?.other));
            setSelectedAccessData(includes(accessType, res?.other));
            setSelectedHomeApplianceData(includes(homeApplianceType, res?.other));
            setSelectedRestrictionData(includes(restrictionsType, res?.other));
          }
          let a = options.filter((e) => res?.propertyType.includes(e.value));
          setPropertyType(a);
    
         
          
          setPrice({ min:res?.priceFrom ? res?.priceFrom: 100, max:res?.priceTo ? res?.priceTo: 2000000 });
           setSize({ min:res?.propertySizeStart ? res?.propertySizeStart  : 0, max:res?.propertySizeEnd ? res?.propertySizeEnd: 10000 });
          res?.availabilityType == "longTerm" ? setLongTerm(true) :setLongTerm(false);
          res?.availabilityType == "shortTerm" ? setShortTerm(true) :  setShortTerm(false);
         
    
          if (res?.availabilityType === "") {
            setLongTerm(false);
            setShortTerm(true);
          }
          if (res?.availabilityTo !== null) {
            setAvailableTo(moment(res?.availabilityTo).toDate());
          }
          if (res?.availabilityFrom !== null) {
            setAvailableFrom(moment(res?.availabilityFrom).toDate());
          }
        }
        });}
      }, [homeApplianceType ]);
    const handleZipCode = () => {
      setOpenZip(!openZip);
      // setMenuOpen(!menuOpen);
    };

    const handleChange = (selectedOption) => {
      setPropertyType(selectedOption);
    };
  const questionArr = [ {
    label:frontLabelsName
    ? frontLabelsName.filter(
      (e) => e.key == "lbl_notification_within_account"
    ).length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_notification_within_account"
      )[0]["value"] || "lbl_notification_within_account"
      : "lbl_notification_within_account"
    : "lbl_notification_within_account",
   id:'web'
 
  }
    ,
    {label:  frontLabelsName
    ? frontLabelsName.filter(
      (e) => e.key == "lbl_by_email"
    ).length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_by_email"
      )[0]["value"] || "lbl_by_email"
      : "lbl_by_email"
    : "lbl_by_email", 
    id:'email',
  
    },
    {label:
    frontLabelsName
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_by_sms"
      ).length > 0
        ? frontLabelsName.filter(
          (e) => e.key == "lbl_by_sms"
        )[0]["value"] || "lbl_by_sms"
        : "lbl_by_sms"
      : "lbl_by_sms",
      id:'sms',

      }
  ];
  


 






  const handleHowWouldYouLikeToNotifiedNew = (data) => {
    setNotified((prevNotified) => {
      if (prevNotified.includes(data.id)) {
        // If the id is already in the notified array, remove it
        return prevNotified.filter((item) => item !== data.id);
      } else {
        // If the id is not in the notified array, add it
        return [...prevNotified, data.id];
      }
    });
  };

  const handlePropertyRoomNew1 = (str) => {
    const multiValues = ['5', '6', '7', '8', '9'];
  
    if (str === '5') {
      setPropertyRoom((prevState) => {
        const hasAll = multiValues.every((v) => prevState.includes(v));
  
        // Toggle: if all are selected, remove them; else add them all
        return hasAll
          ? prevState.filter((v) => !multiValues.includes(v))
          : Array.from(new Set([...prevState, ...multiValues]));
      });
    } else {
      setPropertyRoom((prevState) => {
        if (prevState.includes(str)) {
          return prevState.filter((e) => e !== str);
        } else {
          return [...prevState, str];
        }
      });
    }
  };


  

  const onChange = (value, type) => {
    setPrice(value);

  };


  const onSizeChange = (value, type) => {
    setSize(value);
  
  };

  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }



  const onSubmitNew = () => {
   

    let from_err=""
    let to_err=""
if(longTerm===true || shortTerm === true ){
  from_err = isFutureDate(
    availableFrom,
    "lbl_available_from"
  );
}
    
        if (shortTerm) {
          to_err = isFutureDate(availableTo, "lbl_available_to");
        }

        if(shortTerm && availableTo&& availableFrom){
          let check= isValidDateRange(availableFrom,availableTo)
       
          if(!check){
            to_err = "lbl_available_to_date_should_not_be_before_available_date";
          }else{
            to_err =""
          }
        }

        if(from_err || to_err ){
    
          setFromDateError(frontLabelsName
            ? frontLabelsName.filter((e) => e.key == from_err).length > 0
              ? frontLabelsName.filter((e) => e.key == from_err)[0][
                  "value"
                ] || from_err
              : from_err
            : from_err)
          setToDateError(frontLabelsName
            ? frontLabelsName.filter((e) => e.key == to_err).length > 0
              ? frontLabelsName.filter((e) => e.key == to_err)[0]["value"] ||
              to_err
              : to_err
            : to_err)
        }else{
    
          setFromDateError("")
          setToDateError("")
          
     setDisableSubmitButton(true)
     let temptypeArray = [];
     propertyType?.map((a) => temptypeArray.push(a.value));
 
     
     let concatedArray = selectedOtherData.concat(
       selectedAccessData,
       selectedHomeApplianceData,
       selectedRestrictionData
     );
     const cleanedBhk = propertyRoom.filter(item => item !== "");
     const data = {
       area: checkedTree == undefined ? [] : checkedTree,
       bhk:cleanedBhk ,
       other: [...new Set(concatedArray)],
       propertyType: temptypeArray,
       priceFrom:price.min,
       priceTo:price.max,
       year:'',
       month:'',
       propertySizeStart :size.min,
       propertySizeEnd :size.max,
       location :streetName,
       property_watch_email:notified.includes('email'),
       property_watch_sms:notified.includes('sms'),
property_watch_web:notified.includes('web'),
       availabilityType:
         longTerm === true ? "longTerm" : shortTerm === true ? "shortTerm" : "",
       availabilityTo: longTerm === true ? null : availableTo,
       availabilityFrom: availableFrom,
     };

     addPropertyWatch(data)
       .then((res) => {
         setDisableSubmitButton(false)
         toast.success(
           frontLabelsName
             ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
               ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                   "value"
                 ] || res.data.message
               : res.data.message
             : res.data.message
         );
   
         history.push( "/dashboard");
       })
       .catch((err) => {
         setDisableSubmitButton(false)
         toast.error(
           frontLabelsName
             ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                 .length > 0
               ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
                   "value"
                 ] || err.response.data.message
               : err.response.data.message
             : err.response.data.message
         );
       });
        }

   
  

  };

  // const onReset=()=>{
  //   setNotified([])
  //   setStreetName("")
  //   setCheckedTree(["0"])
  //   setPropertyRoom([])
  //   setSelectedOtherData([])
  //   setSelectedAccessData([])
  //   setSelectedHomeApplianceData([])
  //   setSelectedRestrictionData([])
  //   setPropertyType(null)
  //   setPrice({ min: 100, max: 2000000 })
  //   setSize({min: 0, max: 10000 })
  //   setAvailableFrom(new Date())
  //   setAvailableTo(new Date())
  //   setShortTerm(false)
  //   setLongTerm(false)
  // }


  const handleSkip=()=>{
    dispatch({
      type:"SET_STEP",
      payload:{step:3,status:true}
   });
   localStorage.setItem("currentStepIndex", 3)
  }

  var zipcustom
  if(checkedTree&& checkedTree[0]=="0" ){
    zipcustom=""
  }else {
    zipcustom=checkedTree?.toString()
  }
if(!isSubscribing){
    if (subscription_details !== "Your subscription is active.") {
      swal({
        title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe")[0][
              "value"
            ] || "lbl_purchage_subscribe"
          : "lbl_purchage_subscribe"
        : "lbl_purchage_subscribe",
        text: "",
        icon: "info",
        buttons: [
          null,
            frontLabelsName
           ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
             ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
                 "value"
               ] || "lbl_continue"
             : "lbl_continue"
           : "lbl_continue"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
        }
      });
      return <Redirect to={"/subscription"} />;
    }
  }

   const clearAllData = () => {
    setNotified([])
    setStreetName("")
    setCheckedTree(["0"])
    setPropertyRoom([])
    setSelectedOtherData([])
    setSelectedAccessData([])
    setSelectedHomeApplianceData([])
    setSelectedRestrictionData([])
    setPropertyType(null)
    setPrice({ min: 100, max: 2000000 })
    setSize({min: 0, max: 10000 })
    setAvailableFrom("")
    setAvailableTo("")
    setShortTerm(false)
    setLongTerm(false)
    
    // Clear any error states
    setError_HowWouldYouLikeToNotified("");
    seterror_zipcode("");
    seterror_apartmentType("");
    seterror_propertyRoom("");
    seterror_rentalPeriod("");
    seterror_price("");
    seterror_size("");
    seterror_advance("");
    seterror_streetName("");
    seterror_extraItem("");
    setFromDateError("");
    setToDateError("");
  };

  function getResponsiveStyle() {
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
  
    if (width >= 1000 && width <= 1300) {
      return { minWidth: '1350px' };
    }
  
    return {};
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container main-body ps-3 ps-sm-0 pe-3 pe-sm-0"  style={getResponsiveStyle()}>
        <div className="create-wishlist-main">
          <div className="create-wishlist-box">
               <div className="row">
                            <Label className="asset-watch mb-2 text-center">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_property_watch"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_property_watch"
                                            )[0]["value"] || "lbl_property_watch"
                                          : "lbl_property_watch"
                                        : "lbl_property_watch"}
                                      
                                    </Label>
                            </div>
            <div className="row">
            
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-5 ">
                    {/* <Label className="property-watch-class mb-4">{frontLabelsName
    ? frontLabelsName.filter(
      (e) => e.key == "lbl_asset_watch"
    ).length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_asset_watch"
      )[0]["value"] || "lbl_asset_watch"
      : "lbl_asset_watch"
    : "lbl_asset_watch"}:</Label> */}

                    <div className="asset-col">
          
                 
                      <div className="mb-2 mt-2 p-2 " style={{border:"3px solid black"}}>
                        <Label className="how-you-would font-size-class" >
                        {frontLabelsName
    ? frontLabelsName.filter(
      (e) => e.key == "lbl_how_you_would_like_notified"
    ).length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_how_you_would_like_notified"
      )[0]["value"] || "lbl_how_you_would_like_notified"
      : "lbl_how_you_would_like_notified"
    : "lbl_how_you_would_like_notified"}
                          {" "}
                      
                        </Label>
                        {questionArr.map((data, key, arr) => {
                          return (
                            <>
                              <div
                                className="d-flex justify-content-between align-items-center mt-1 checkboxx"
                                key={data.id}
                              >
                                <Label className="notification-within-account">
                                  {data.label}
                                </Label>
                                
                                <input
                                  type="checkbox"
                                  className="rounded-checkbox"
                                  checked={
                                    notified.includes(
                                      data.id
                                    )
                                     
                                  }
                                  onClick={() =>
                                    handleHowWouldYouLikeToNotifiedNew(data)
                                  }
                                ></input>
                                 
                              </div>
                         

                              {key + 1 < arr.length ? <hr /> : ""}
                            </>
                          );
                        })}
                        {error_howWouldYouLikeToNotified && (
                          <span className="invalid_span">
                            {error_howWouldYouLikeToNotified}
                          </span>
                        )}
                      </div>
                      <div className="mt-3 mb-3">
               
                             <input
                                  type="text"
                                  name="Enter Zip Code"
                                  placeholder={
                                    frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_zip_code"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_zip_code"
                                          )[0]["value"] || "lbl_zip_code"
                                        : "lbl_zip_code"
                                      : "lbl_zip_code"
                                  }
                                    className="zip-code1 "
                                  autocomplete="off"
                                  onClick={handleZipCode}
                                  value={zipcustom}
                                  //style={{ color: "transparent" }}
                                  // onChange={onFilterChange}
                                />
                                {openZip && (
                                  <div className="zipcode-style">
                                                 <PerfectScrollbar
                  style={{
                 
                    maxHeight:"300px",
                    overflowX: "hidden",
                  
                    width:"100%"
                  }}
            
                 
                >
                                    <CheckboxTree
                                      nodes={nodes}
                                      checked={checkedTree}
                                      expanded={expandedTree}
                                      expandOnClick={true}
                                      onClick={(clickedTree) =>
                                        setClickedTree(clickedTree)
                                      }
                                      onCheck={(checkedTree) => {
                                        setCheckedTree(checkedTree);
                                      }}
                                      onExpand={(expandedTree) =>
                                        setExpandedTree(expandedTree)
                                      }
                                      icons={icons}
                                      // nativeCheckboxes={true}
                                    />
                                    </PerfectScrollbar>
                                  </div>
                                )}
                        {error_zipcode && (
                          <span className="invalid_span">{error_zipcode}</span>
                        )}
                      </div>

                      <div className="mt-3 mb-2 set-bg-feild11">
                      <ReactSelect
                                  // defaultValue={propertyType}
                                  className="renter-react-style"
                                  styles={colourStyles}
                                  components={animatedComponents}
                                  placeholder={
                                    frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_select_property_type"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) =>
                                              e.key ==
                                              "lbl_select_property_type"
                                          )[0]["value"] ||
                                          "lbl_select_property_type"
                                        : "lbl_select_property_type"
                                      : "lbl_select_property_type"
                                  }
                                  name="property type"
                                  options={options}
                                  onChange={handleChange}
                                  value={propertyType}
                                  isClearable
                                  isMulti
                                />
       

                        {error_apartmentType && (
                          <span className="invalid_span">
                            {error_apartmentType}
                          </span>
                        )}
                      </div>

                      <Label className="how-you-would mt-4 mb-2 font-size-class">
                      {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_property_room")
                                  .length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_property_room"
                                  )[0]["value"] || "lbl_property_room"
                                  : "lbl_property_room"
                                : "lbl_property_room"} 
                      </Label>
                      <h6 className="notification-within-account">{frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_bedroom")
                                  .length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_bedroom"
                                  )[0]["value"] || "lbl_bedroom"
                                  : "lbl_bedroom"
                                : "lbl_bedroom"}</h6>
                      <div className="link-btn-sets">
                        {/* set-bg-btn-no */}
                        {propertyRoomArr.map((data, key) => {
                          return data !==5 ? (
                            <button
                              key={key}
                              className={`${
                                propertyRoom?.includes(data.value)
                                  ? "set-bg-btn-no-room custom-width"
                                  : "set-bg-btn-no2-room custom-width"
                              }`}
                              onClick={() => handlePropertyRoomNew1(data.value)}
                            >
                              {data.label}
                            </button>
                          ) : (
                            <button
                              key={key}
                              className={`${
                                propertyRoom?.includes(data.value)
                                  ? "set-bg-btn-no-room custom-width"
                                  : "set-bg-btn-no2-room custom-width"
                              }`}
                              onClick={() => handlePropertyRoomNew1(data.value)}
                            >
                              {data.label}+
                            </button>
                          );
                        })}
                        {error_propertyRoom && (
                          <span className="invalid_span">
                            {error_propertyRoom}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-7 ">
                    <div className="row slider-class">
                      <div className="col-lg-12 ps-0">
                        <Label className="property-watch-class mb-4 mt-3 mt-lg-0">
                          
                          {frontLabelsName
    ? frontLabelsName.filter(
      (e) => e.key == "lbl_let_leigulistan_find_the_apartment"
    ).length > 0
      ? frontLabelsName.filter(
        (e) => e.key == "lbl_let_leigulistan_find_the_apartment"
      )[0]["value"] || "lbl_let_leigulistan_find_the_apartment"
      : "lbl_let_leigulistan_find_the_apartment"
    : "lbl_let_leigulistan_find_the_apartment"}
                        </Label>
                      </div>
                      <div className="col-lg-5 asset-col ps-0">
                        <div>
                          <h4 className="how-you-would font-size-class">
                              {
                            frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_rental_period"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_rental_period"
                                )[0]["value"] || "lbl_rental_period"
                                : "lbl_rental_period"
                              : "lbl_rental_period"
                          }{" "}
                         
                          </h4>
                          <div>
                          
                                  <div
                                    className="d-flex justify-content-between align-items-center pt-2 checkboxx"
                                
                                  >
                                    <Label className="notification-within-account">
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_available_now"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_available_now"
                                          )[0]["value"] || "lbl_available_now"
                                        : "lbl_available_now"
                                      : "lbl_available_now"}
                                    </Label>
                                    <input
                                      type="checkbox"
                                      className="rounded-checkbox"
                                      value={shortTerm}
                                      name="availableType"
                                      onChange={() => {
                                        if (shortTerm !== true) {
                                          setLongTerm(false);
                                          setShortTerm(true);
                                        }
                                      }}
                                      checked={shortTerm === true}
                                    ></input>
                                  </div>
                                   <hr /> 
                             
                                   <div
                                    className="d-flex justify-content-between align-items-center pt-2 checkboxx"
                                
                                  >
                                    <Label className="notification-within-account">
                                    {frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_long_term"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_long_term"
                                          )[0]["value"] || "lbl_long_term"
                                        : "lbl_long_term"
                                      : "lbl_long_term"}
                                    </Label>
                                    <input
                                      type="checkbox"
                                      className="rounded-checkbox"
                                      value={longTerm}
                                      name="availableType"
                                      onChange={() => {
                                        if (longTerm !== true) {
                                          setLongTerm(true);
                                          setShortTerm(false);
                                        }
                                      }}
                                      checked={longTerm === true}
                                    ></input>
                                  </div>
                             
                        
                            {error_rentalPeriod && (
                              <span className="invalid_span">
                                {error_rentalPeriod}
                              </span>
                            )}
                          </div>
                          <hr />
                          <div className="pt-1 ">
                       
                          {(shortTerm === true || longTerm===true) && (    <div className="search-div ">
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                            <label style={{padding:"2px",marginBottom:"5px"}}>{frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_available_from"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_available_from"
                                )[0]["value"] || "lbl_available_from"
                                : "lbl_available_from"
                              : "lbl_available_from"}{" "}: </label>
                            <DatePicker
                              placeholderText= {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_available_from_date"
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_available_from_date"
                                  )[0]["value"] || "lbl_available_from_date"
                                  : "lbl_available_from_date"
                                : "lbl_available_from_date"}
                              dateFormat="dd/MM/yyyy "
                              name="expiryDate"
                              // showTimeSelect
                              selected={availableFrom}
                              onChange={(date) =>
                                setAvailableFrom(date)
                              }
                              className="zip-code"
                              isClearable={availableFrom ? true : false}
                              minDate={new Date()}
                            />

                            <span className="calendar-icon">
                              <FaRegCalendarAlt />
                            </span>
                            {fromDateError && (
                              <span className="invalid_span">
                                {fromDateError}
                              </span>
                            )}
                          </div>)}
                          {shortTerm === true && (
                                         
                       
                                          <div className="search-div mt-2">
                                    <Label>{frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_available_to"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_available_to"
                                )[0]["value"] || "lbl_available_to"
                                : "lbl_available_to"
                              : "lbl_available_to"}</Label>
                                            <DatePicker
                                              placeholderText=      {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_available_to"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_available_to"
                                                    )[0]["value"] || "lbl_available_to"
                                                  : "lbl_available_to"
                                                : "lbl_available_to"}
                                              dateFormat="dd/MM/yyyy "
                                              name="expiryDate"
                                              // showTimeSelect
                                              selected={availableTo}
                                              onChange={(date) =>
                                                setAvailableTo(date)
                                              }
                                              className="zip-code"
                                              isClearable={availableTo ? true : false}
                                              minDate={new Date()}
                                            />
                
                                            <span className="calendar-icon">
                                              <FaRegCalendarAlt />
                                            </span>
                                            {toDateError && (
                              <span className="invalid_span">
                                {toDateError}
                              </span>
                            )}
                                          </div>
                          )}
                          <div>
                            {error_advance && (
                              <span className="invalid_span">
                                {error_advance}
                              </span>
                            )}
                          </div>
                        </div>

                          <div className="Property_Price padding-style">
                            <h2 className="font-size-class">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_property_price"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_property_price"
                                )[0]["value"] || "lbl_property_price"
                                : "lbl_property_price"
                              : "lbl_property_price"}{" "}
                            
                            </h2>
                            <span className="font-size-classXX">
                            kr {priceFormat(price.min)} - kr {priceFormat( price.max) }+
                            </span>
                            <div>
                              <div className="pt-3 ">
                                <InputRange
                                  step={5}
                                  formatLabel={(value) => null}
                                  draggableTrack={false}
                                  allowSameValues={false}
                                  maxValue={2000000}
                                  minValue={0}
                                  value={price}
                                  onChange={onChange}
                                />
                              </div>
                            </div>
                          </div>
                    
                          <div className="pt-2">
                         
                            {error_price && (
                              <span className="invalid_span">
                                {error_price}
                              </span>
                            )}
                          </div>
                         
                          <div className="Property_Price padding-style">
                            <h2 className="font-size-class">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_property_size"
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_property_size"
                                )[0]["value"] || "lbl_property_size"
                                : "lbl_property_size"
                              : "lbl_property_size"}{" "}
                    
                            </h2>
                            <span className="font-size-classXX">
                              {priceFormat(size.min)} - {priceFormat(size.max)} m<sup>2</sup>
                            </span>
                            <div>
                              <div className="pt-3 ">
                                <InputRange
                                  step={5}
                                  formatLabel={(value) => null}
                                  draggableTrack={false}
                                  allowSameValues={false}
                                  maxValue={10000}
                                  minValue={0}
                                  value={size}
                                  onChange={onSizeChange}
                                />
                              </div>
                            </div>
                          </div>
                        
                          <div className="pt-2">
                            {error_size && (
                              <span className="invalid_span">{error_size}</span>
                            )}
                          </div>
                        </div>
                        <div className="fake-heightxx">

                        </div>
                      </div>
                      <div className="col-lg-7 col-md-12">
                        <h4 className="how-you-would font-size-class">
                        {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_advanced")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_advanced"
                                )[0]["value"] || "lbl_advanced"
                                : "lbl_advanced"
                              : "lbl_advanced"} 
                        </h4>

                       
                        <div className=" mt-4 mb-4">
                          <div className="search-div">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_search_street_name"
                                  ).length > 0
                                    ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_search_street_name"
                                    )[0]["value"] || "lbl_search_street_name"
                                    : "lbl_search_street_name"
                                  : "lbl_search_street_name"
                              }
                              onChange={(e)=>setStreetName(e.target.value)}
                              value={streetName}
                              className="zip-code "
                            />
                            <span className="search-icon">
                              <FiSearch />
                            </span>
                          </div>
                          {error_streetName && (
                            <span className="invalid_span">
                              {error_streetName}
                            </span>
                          )}
                        </div>
                        <div className="Property_Price" >
                          <h2 className="font-size-class">
                           {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_other_filters")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_other_filters"
                                )[0]["value"] || "lbl_other_filters"
                                : "lbl_other_filters"
                              : "lbl_other_filters"}:
                              </h2>
                        </div>
                        <div className="row mt-2">
                        <div className="col-lg-6 col-md-6   pe-0">
                            {otherTypeField?.length > 0 && otherTypeField.map((data, key) => {
                              return (
                                <div class="form-group mb-3 d-flex " key={key}>
                                  <input
                                    type="checkbox"
                                    id={data._id}
                                    value={data._id}
                                    checked={selectedOtherData?.includes(
                                      data._id
                                    )}
                                    className="advanced-checkbox"
                                 
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedOtherData([
                                          ...selectedOtherData,
                                          e.target.value,
                                        ]);
                                      } else {
                                        const filterVal =
                                        selectedOtherData.filter(
                                            (val, i) =>
                                              val !== e.target.value
                                          );
                                          setSelectedOtherData(
                                          filterVal
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                   htmlFor={data._id}
                                
                                    className="with-furniture ps-2"
                                  >
                                 {Array.isArray(data?.name) ? data?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:data?.name }
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                       
                          <div className="col-lg-6 col-md-6   pe-0">
                            {restrictionsType?.length > 0 && restrictionsType.map((data, key) => {
                              return (
                                <div class="form-group mb-3 d-flex " key={key}>
                                  <input
                                    type="checkbox"
                                    id={data._id}
                                    value={data._id}
                                    checked={selectedRestrictionData?.includes(
                                      data._id
                                    )}
                                    className="advanced-checkbox"
                                 
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedRestrictionData([
                                          ...selectedRestrictionData,
                                          e.target.value,
                                        ]);
                                      } else {
                                        const filterVal =
                                        selectedRestrictionData.filter(
                                            (val, i) =>
                                              val !== e.target.value
                                          );
                                          setSelectedRestrictionData(
                                          filterVal
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                   htmlFor={data._id}
                                
                                    className="with-furniture ps-2"
                                  >
                                 {Array.isArray(data?.name) ? data?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:data?.name }
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                          <div className="col-lg-6 col-md-6   pe-0">
                            {accessType?.length > 0 && accessType.map((data, key) => {
                              return (
                                <div class="form-group mb-3 d-flex " key={key}>
                                  <input
                                    type="checkbox"
                                    id={data._id}
                                    value={data._id}
                                    checked={selectedAccessData?.includes(
                                      data._id
                                    )}
                                    className="advanced-checkbox"
                                 
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedAccessData([
                                          ...selectedAccessData,
                                          e.target.value,
                                        ]);
                                      } else {
                                        const filterVal =
                                        selectedAccessData.filter(
                                            (val, i) =>
                                              val !== e.target.value
                                          );
                                          setSelectedAccessData(
                                          filterVal
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                   htmlFor={data._id}
                                
                                    className="with-furniture ps-2"
                                  >
                                 {Array.isArray(data?.name) ? data?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:data?.name }
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                          <div className="col-lg-6 col-md-6   pe-0">
                            {homeApplianceType?.length > 0 && homeApplianceType?.map((data, key) => {
                              return (
                                <div class="form-group mb-3 d-flex " key={key}>
                                  <input
                                    type="checkbox"
                                    id={data._id}
                                    value={data._id}
                                    checked={selectedHomeApplianceData?.includes(
                                      data._id
                                    )}
                                    className="advanced-checkbox"
                                    // onClick={() => handleExtraItemNew(data)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedHomeApplianceData([
                                          ...selectedHomeApplianceData,
                                          e.target.value,
                                        ]);
                                      } else {
                                        const filterVal =
                                          selectedHomeApplianceData.filter(
                                            (val, i) =>
                                              val !== e.target.value
                                          );
                                        setSelectedHomeApplianceData(
                                          filterVal
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                   htmlFor={data._id}
                                
                                    className="with-furniture ps-2"
                                  >
                                 {Array.isArray(data?.name) ? data?.name?.filter((e)=>(  (e[lng])))[0][lng]['name']:data?.name }
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                  
                          {error_extraItem && (
                            <span className="invalid_span">
                              {error_extraItem}
                            </span>
                          )}
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
            </div>
            <div className="row  mb-1">
                          <div className="col-lg-12">
                            <div className="button-create-watchlist text-center d-flex justify-content-end gap-3">
                            {/* <button className="reset-btn font-14-class" onClick={onReset}>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_clear")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_clear"
                            )[0]["value"] || "lbl_clear"
                            : "lbl_clear"
                          : "lbl_clear"}
                      </button> */}
                 
                        {/* <Link to="/update-renter-info" className="link-style" >
                              <Button className="btn-size property-watch-button-class">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_skip"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_skip"
                                      )[0]["value"] || "lbl_skip"
                                    : "lbl_skip"
                                  : "lbl_skip"}
                              </Button>
                            </Link>  */}

                            <button className="reset-btn font-14-class" onClick={()=>clearAllData()}>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_clear")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_clear"
                            )[0]["value"] || "lbl_clear"
                            : "lbl_clear"
                          : "lbl_clear"}
                      </button>
                     
                              <Button className="font-14-class " onClick={onSubmitNew}    disabled={disableSubmitButton}>
                               {disableSubmitButton ? (
                                                       <CircularProgress
                                                         size={24}
                                                         sx={{
                                                           ":hover": { color: "#000" },
                                                          mt:1,
                                                           color: "#000",
                                                          
                                                         }}
                                                       />
                                                     ) : frontLabelsName
                                                     ? frontLabelsName.filter((e) => e.key == "lbl_create_wishlist")
                                                       .length > 0
                                                       ? frontLabelsName.filter(
                                                         (e) => e.key == "lbl_create_wishlist"
                                                       )[0]["value"] || "lbl_create_wishlist"
                                                       : "lbl_create_wishlist"
                                                     : "lbl_create_wishlist"}  
                              </Button>
                  
                            </div>
                          </div>
                        </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  
  label: state.language,
});
export default connect(mapStateToProps, {runningSubscription,dropdownPropertyField,addPropertyWatch, getPropertyWatch,})(PropertiesWatch);